/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableWithoutClose,
  PurchasableWithoutCloseOptional,
  PurchasableWithoutCloseMetaI,
  PurchasableWithoutCloseTrackedI,
} from "./purchasable-without-close";
import {
  PurchasableWithoutCloseTracked,
  PurchasableWithoutCloseMeta,
} from "./purchasable-without-close";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StockChangeType,
  StockChangeTypeOptional,
  StockChangeTypeMetaI,
  StockChangeTypeTrackedI,
} from "./stock-change-type";
import {
  StockChangeTypeTracked,
  StockChangeTypeMeta,
} from "./stock-change-type";

/**
 *
 * @export
 * @interface ItemInstanceStockChangeBase
 */
export interface ItemInstanceStockChangeBaseOptional extends PurchasableWithoutCloseOptional {
  /**
   *
   * @type {PurchasableState}
   * @memberof ItemInstanceStockChangeBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof ItemInstanceStockChangeBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof ItemInstanceStockChangeBase
   */
  changeAmount?: number;
  /**
   *
   * @type {StockChangeType}
   * @memberof ItemInstanceStockChangeBase
   */
  stockChangeType?: StockChangeType;
}

export interface ItemInstanceStockChangeBase
  extends ItemInstanceStockChangeBaseOptional, PurchasableWithoutClose {
  /**
   *
   * @type {PurchasableState}
   * @memberof ItemInstanceStockChangeBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof ItemInstanceStockChangeBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof ItemInstanceStockChangeBase
   */
  changeAmount: number;
  /**
   *
   * @type {StockChangeType}
   * @memberof ItemInstanceStockChangeBase
   */
  stockChangeType: StockChangeType;
}

export interface ItemInstanceStockChangeBaseTrackedI extends PurchasableWithoutCloseOptional {
  /**
   *
   * @type {PurchasableState}
   * @memberof ItemInstanceStockChangeBase
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ItemInstanceStockChangeBase
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ItemInstanceStockChangeBase
   */
  changeAmount?: number;
  changeAmountIsSet: boolean;
  /**
   *
   * @type {StockChangeType}
   * @memberof ItemInstanceStockChangeBase
   */
  stockChangeType?: StockChangeType;
  stockChangeTypeIsSet: boolean;
}

transformDatesMap.set(
  "ItemInstanceStockChangeBase",
  function (model: ItemInstanceStockChangeBase) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
  },
);

export type ItemInstanceStockChangeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  changeAmount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  stockChangeType: PropertyMeta<StockChangeTypeMetaI>;
}>;

export var ItemInstanceStockChangeBaseMeta: ItemInstanceStockChangeBaseMetaI =
  {} as ItemInstanceStockChangeBaseMetaI;
ItemInstanceStockChangeBaseMeta = typeMeta("ItemInstanceStockChangeBase", {
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  changeAmount: propertyMeta(
    "changeAmount",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  stockChangeType: propertyMeta(
    "stockChangeType",
    false,
    true,
    false,
    StockChangeTypeMeta,
  ),
});

const metaI = ItemInstanceStockChangeBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PurchasableWithoutCloseMeta]);
  metaI.purchasableState.inheritedFrom =
    PurchasableWithoutCloseMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = PurchasableWithoutCloseMeta.purchaseDate;
});

export class ItemInstanceStockChangeBaseTracked
  extends PurchasableWithoutCloseTracked
  implements ItemInstanceStockChangeBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  changeAmount__I?: number = undefined;
  changeAmountIsSet: boolean = false;
  set changeAmount(v: undefined | number) {
    if (v !== undefined) {
      this.changeAmount__I = v;
      this.changeAmountIsSet = true;
    } else {
      this.changeAmount__I = v || undefined;
      this.changeAmountIsSet = true;
    }
    this.changeTracker = true;
  }
  get changeAmount() {
    return this.changeAmount__I;
  }
  stockChangeType__I?: StockChangeType = undefined;
  stockChangeTypeIsSet: boolean = false;
  set stockChangeType(v: undefined | StockChangeType) {
    if (v !== undefined) {
      this.stockChangeType__I = v;
      this.stockChangeTypeIsSet = true;
    } else {
      this.stockChangeType__I = v || undefined;
      this.stockChangeTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get stockChangeType() {
    return this.stockChangeType__I;
  }
  constructor(
    config?: ItemInstanceStockChangeBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ItemInstanceStockChangeBaseOptional,
    options?: AssignOptions,
  ): ItemInstanceStockChangeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.changeAmount &&
      this.changeAmountApplyFilter(optionsRequired.filter)
    ) {
      this.changeAmount = config.changeAmount;
      if (optionsRequired.unassign) this.changeAmountIsSet = false;
      else this.changeAmountIsSet = true;
    }
    if (
      config.stockChangeType &&
      this.stockChangeTypeApplyFilter(optionsRequired.filter)
    ) {
      this.stockChangeType = config.stockChangeType;
      if (optionsRequired.unassign) this.stockChangeTypeIsSet = false;
      else this.stockChangeTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ItemInstanceStockChangeBaseTrackedI {
    const cloned = {} as ItemInstanceStockChangeBaseTrackedI;
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.changeAmountIsSetDeep() &&
      this.changeAmountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.changeAmountIsSet = true;
      cloned.changeAmount = this.changeAmount;
    } else {
      //cloned.changeAmountIsSet = false
    }
    if (
      this.stockChangeTypeIsSetDeep() &&
      this.stockChangeTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stockChangeTypeIsSet = true;
      cloned.stockChangeType = this.stockChangeType;
    } else {
      //cloned.stockChangeTypeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ItemInstanceStockChangeBaseTrackedI {
    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.changeAmountApplyFilter(filter)) this.changeAmountIsSet = false;

    if (!this.stockChangeTypeApplyFilter(filter))
      this.stockChangeTypeIsSet = false;

    return this;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemInstanceStockChangeBaseMeta.purchasableState,
      ItemInstanceStockChangeBaseMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemInstanceStockChangeBaseMeta.purchaseDate,
      ItemInstanceStockChangeBaseMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  changeAmountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemInstanceStockChangeBaseMeta.changeAmount,
      ItemInstanceStockChangeBaseMeta,
      this.changeAmount,
      this,
    );
  }
  changeAmountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.changeAmountIsSet && this.changeAmountApplyFilter(filter))
      return true;

    return false;
  }
  stockChangeTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemInstanceStockChangeBaseMeta.stockChangeType,
      ItemInstanceStockChangeBaseMeta,
      this.stockChangeType,
      this,
    );
  }
  stockChangeTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stockChangeTypeIsSet && this.stockChangeTypeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.changeAmountIsSetDeep(filter)) return true;
    if (this.stockChangeTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
